"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeItemStatus = void 0;
var ChangeItemStatus;
(function (ChangeItemStatus) {
    ChangeItemStatus[ChangeItemStatus["InReview"] = 1] = "InReview";
    ChangeItemStatus[ChangeItemStatus["Open"] = 2] = "Open";
    ChangeItemStatus[ChangeItemStatus["Approved"] = 3] = "Approved";
    ChangeItemStatus[ChangeItemStatus["Rejected"] = 4] = "Rejected";
    ChangeItemStatus[ChangeItemStatus["Closed"] = 5] = "Closed";
    ChangeItemStatus[ChangeItemStatus["Reviewed"] = 6] = "Reviewed";
    ChangeItemStatus[ChangeItemStatus["Reopened"] = 7] = "Reopened";
    ChangeItemStatus[ChangeItemStatus["PendingProposal"] = 8] = "PendingProposal";
    ChangeItemStatus[ChangeItemStatus["ProposalReceived"] = 9] = "ProposalReceived";
    ChangeItemStatus[ChangeItemStatus["ProposalInReview"] = 10] = "ProposalInReview";
    ChangeItemStatus[ChangeItemStatus["ProposalReviewed"] = 11] = "ProposalReviewed";
    ChangeItemStatus[ChangeItemStatus["PendingSignature"] = 12] = "PendingSignature";
    ChangeItemStatus[ChangeItemStatus["ProposalApproved"] = 13] = "ProposalApproved";
    ChangeItemStatus[ChangeItemStatus["ProposalRejected"] = 14] = "ProposalRejected";
    ChangeItemStatus[ChangeItemStatus["Delivered"] = 15] = "Delivered";
    ChangeItemStatus[ChangeItemStatus["Pending"] = 16] = "Pending";
})(ChangeItemStatus = exports.ChangeItemStatus || (exports.ChangeItemStatus = {}));
//# sourceMappingURL=ChangeItemStatus.js.map